import { render, staticRenderFns } from "./PainterChat.vue?vue&type=template&id=5db1014c&scoped=true"
import script from "./PainterChat.vue?vue&type=script&lang=js"
export * from "./PainterChat.vue?vue&type=script&lang=js"
import style0 from "./PainterChat.vue?vue&type=style&index=0&id=5db1014c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1014c",
  null
  
)

export default component.exports